import * as React from 'react'
import { masks, onlyNumbersLetters } from 'util/mask'

import { MaskedField, MaskedFieldProps } from '../final-form'

export const ContraChaveField = (props: MaskedFieldProps) => {
  return <MaskedField mask={masks.contra_chave} parse={onlyNumbersLetters} {...props} />
}
